var map = {
	"./Block/Controls/RightSide/Design/index": "./src/Widget/Widgets/Block/Controls/RightSide/Design/index.js",
	"./Block/Controls/RightSide/index": "./src/Widget/Widgets/Block/Controls/RightSide/index.js",
	"./Block/Controls/index": "./src/Widget/Widgets/Block/Controls/index.js",
	"./Block/Resize/index": "./src/Widget/Widgets/Block/Resize/index.js",
	"./Block/index": "./src/Widget/Widgets/Block/index.js",
	"./Block/libs/index": "./src/Widget/Widgets/Block/libs/index.js",
	"./Button/Controls/index": "./src/Widget/Widgets/Button/Controls/index.js",
	"./Button/index": "./src/Widget/Widgets/Button/index.js",
	"./Button/libs/index": "./src/Widget/Widgets/Button/libs/index.js",
	"./Captcha/Controls/index": "./src/Widget/Widgets/Captcha/Controls/index.js",
	"./Captcha/index": "./src/Widget/Widgets/Captcha/index.js",
	"./Captcha/libs/index": "./src/Widget/Widgets/Captcha/libs/index.js",
	"./Code/Controls/index": "./src/Widget/Widgets/Code/Controls/index.js",
	"./Code/index": "./src/Widget/Widgets/Code/index.js",
	"./Code/libs/index": "./src/Widget/Widgets/Code/libs/index.js",
	"./Col/Controls/Design/index": "./src/Widget/Widgets/Col/Controls/Design/index.js",
	"./Col/Controls/index": "./src/Widget/Widgets/Col/Controls/index.js",
	"./Col/index": "./src/Widget/Widgets/Col/index.js",
	"./Col/libs/index": "./src/Widget/Widgets/Col/libs/index.js",
	"./Col/libs/with-drop-place/index": "./src/Widget/Widgets/Col/libs/with-drop-place/index.js",
	"./Image/Controls/index": "./src/Widget/Widgets/Image/Controls/index.js",
	"./Image/index": "./src/Widget/Widgets/Image/index.js",
	"./Image/libs/index": "./src/Widget/Widgets/Image/libs/index.js",
	"./Input/Controls/index": "./src/Widget/Widgets/Input/Controls/index.js",
	"./Input/index": "./src/Widget/Widgets/Input/index.js",
	"./Input/libs/index": "./src/Widget/Widgets/Input/libs/index.js",
	"./Page/WidgetAdd/WidgetPanel/index": "./src/Widget/Widgets/Page/WidgetAdd/WidgetPanel/index.js",
	"./Page/WidgetAdd/index": "./src/Widget/Widgets/Page/WidgetAdd/index.js",
	"./Page/index": "./src/Widget/Widgets/Page/index.js",
	"./Page/libs/index": "./src/Widget/Widgets/Page/libs/index.js",
	"./Project/Presets/index": "./src/Widget/Widgets/Project/Presets/index.js",
	"./Project/libs/index": "./src/Widget/Widgets/Project/libs/index.js",
	"./Rectangle/Controls/index": "./src/Widget/Widgets/Rectangle/Controls/index.js",
	"./Rectangle/index": "./src/Widget/Widgets/Rectangle/index.js",
	"./Rectangle/libs/index": "./src/Widget/Widgets/Rectangle/libs/index.js",
	"./Site/index": "./src/Widget/Widgets/Site/index.js",
	"./Site/libs/index": "./src/Widget/Widgets/Site/libs/index.js",
	"./Spacer/Controls/index": "./src/Widget/Widgets/Spacer/Controls/index.js",
	"./Spacer/index": "./src/Widget/Widgets/Spacer/index.js",
	"./Spacer/libs/index": "./src/Widget/Widgets/Spacer/libs/index.js",
	"./Stack/Controls/index": "./src/Widget/Widgets/Stack/Controls/index.js",
	"./Stack/index": "./src/Widget/Widgets/Stack/index.js",
	"./Stack/libs/index": "./src/Widget/Widgets/Stack/libs/index.js",
	"./Text/Controls/InlineStyles/index": "./src/Widget/Widgets/Text/Controls/InlineStyles/index.js",
	"./Text/Controls/index": "./src/Widget/Widgets/Text/Controls/index.js",
	"./Text/index": "./src/Widget/Widgets/Text/index.js",
	"./Textarea/Controls/index": "./src/Widget/Widgets/Textarea/Controls/index.js",
	"./Textarea/index": "./src/Widget/Widgets/Textarea/index.js",
	"./Textarea/libs/index": "./src/Widget/Widgets/Textarea/libs/index.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/Widget/Widgets sync recursive ^\\.\\/.*\\/index$";